const debug = (message: any) => {
  if (import.meta.env.VITE_ENV === "development") {
    console.log(message);
  }
};

const error = (message: string, err?: unknown) => {
  console.error(message, err);
};

const Logger = { debug, error };
export default Logger;
